import { EntityList, EntityListProps, renderEnum } from 'components/EntityList'
import { OptionsSetting, SingleValueSetting } from 'model'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type AdminOptionsListProps = EntityListProps<
  OptionsSetting | SingleValueSetting
>

export const AdminKeywordList: React.FunctionComponent<
  AdminOptionsListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('type', {
        minWidth: 140,
        onRender: renderEnum(t, 'keywordType'),
        ungroupable: true,
      }),
      fieldColumn('values', {
        minWidth: 140,
        onRender: (item: OptionsSetting & SingleValueSetting) => {
          if (item.options) {
            return item.options.join(', ')
          }
          if (item.value) {
            return item.value
          }
          return ''
        },
      }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.single}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
